import React from 'react';
import { HomePageMobile } from '@/components/HomePage/HomePage.mobile';
import { withBlockingErrorBoundary } from '@/HOC/runTimeErrors';
import { useHomePageAction } from '@/components/HomePage/useAction';
import { PAX, usePriceFreezeRouter } from '@/hooks/usePriceFreezeRouter';
import { Mobile } from '@edreamsodigeo/frontend-core';
import { NotAvailableProvider } from '@/providers/NotAvailableProvider';
import { PrimeBenefitsLinkProvider } from '@/providers/PrimeBenefitsLinkProvider';

export function HomePageContainer({ primeBenefitsLink }) {
  const router = usePriceFreezeRouter();
  return (
    <NotAvailableProvider onPopupClose={() => router.back()}>
      <PrimeBenefitsLinkProvider primeBenefitsLink={primeBenefitsLink}>
        <HomePage primeBenefitsLink={primeBenefitsLink} />
      </PrimeBenefitsLinkProvider>
    </NotAvailableProvider>
  );
}

export function HomePage() {
  const router = usePriceFreezeRouter();
  const { loading, error, onContinue, toggleError } = useHomePageAction({
    onContinue() {
      router.navigateTo(PAX);
    },
  });

  return (
    <Mobile>
      <HomePageMobile
        loading={loading}
        onContinue={onContinue}
        error={error}
        toggleError={toggleError}
      />
    </Mobile>
  );
}

export const PublicHomePage = withBlockingErrorBoundary(HomePageContainer, {
  name: 'HomePageError',
});

export function convertPrimeUserToContactDetails(user, countries = []) {
  if (!user) return null;

  return {
    name: user.personalInfo.name,
    surname:
      user.personalInfo.firstLastName +
      (user.personalInfo.secondLastName
        ? ' ' + user.personalInfo.secondLastName
        : ''),
    email: user.email,
    country_code: countries.find(
      (country) => country.code === user.prefixPhoneNumber
    )?.phonePrefix,
    phone: user.phoneNumber || user.mobilePhoneNumber,
  };
}
